import { Form, Input, Modal } from 'antd';
import { useCallback, useEffect } from 'react';

import type { FC } from 'react';

const { TextArea } = Input;
const { useForm, Item } = Form;

interface AddCommentModalProps {
  isOpen: boolean;
  title: string;
  commentText: string;
  isSaving: boolean;
  onCommentTextChange(commentText: string): void;
  onSave(commentText: string): Promise<boolean>;
  onCancel(): void;
}

interface LeadCardCommentFormValues {
  Comment: string;
}

export const AddCommentModal: FC<AddCommentModalProps> = ({
  isOpen,
  title,
  commentText,
  isSaving,
  onCommentTextChange,
  onSave,
  onCancel,
}) => {
  const [form] = useForm<LeadCardCommentFormValues>();
  const { resetFields, setFieldValue, submit } = form;

  const finishHandler = useCallback(
    async ({ Comment }: LeadCardCommentFormValues) => {
      onCommentTextChange(Comment);
      await onSave(Comment);
    },
    [onCommentTextChange, onSave]
  );

  const cancelHandler = useCallback(() => {
    resetFields();
    onCancel();
  }, [resetFields, onCancel]);

  useEffect(() => {
    if (!isOpen) {
      resetFields();
      return;
    }

    setFieldValue('Comment', commentText);
  }, [commentText, resetFields, setFieldValue, isOpen]);

  return (
    <Modal
      title={title}
      okText="Сохранить"
      cancelText="Отменить"
      open={isOpen}
      onOk={submit}
      onCancel={cancelHandler}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      destroyOnHidden
    >
      <Form form={form} onFinish={finishHandler}>
        <Item
          name="Comment"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Необходимо ввести как минимум 1 символ',
            },
            {
              max: 2000,
              message: 'Превышено максимальное количество символов',
            },
          ]}
        >
          <TextArea
            rows={4}
            maxLength={2000}
            onChange={({ target: { value } }) => onCommentTextChange(value)}
          />
        </Item>
      </Form>
    </Modal>
  );
};
